import * as React from 'react';
import 'core-js/fn/object/assign';

const Button = (props) => {
    let btnColor = props.color.toLowerCase();
    if(props.outline) {
        btnColor = "btn-outline-" + btnColor;
    } else {
        btnColor = "btn-" + btnColor;
    }
    return (
        <div className={props.divClassName!=null ?props.divClassName:"display-flex"} style={props.divStyle!=null?props.divStyle:{width:"100%"}}>
            <button type="button" className={`btn ${btnColor} ${props.className!=null?props.className:null }`} disabled={props.disabled ? true : false} onClick={props.onClick != null || props.onClick != undefined ? props.onClick.bind(this) : null} style={props.style}>
                {props.icon && <i className={`fa ${props.icon}`}></i>}
                {props.hideLabel !== true && props.label}
            </button>
        </div>
    )
}

export default Button;


// WEBPACK FOOTER //
// ./components/forms/button/index.jsx